window.addEventListener("DOMContentLoaded", () => {
  const url = new URL(window.location.href);
  const pageState = url.searchParams.get("page");
  const goCart2Button = document.querySelector("button[name='checkout']");

  // 刻印選択されて商品がカートにあるかチェック
  initIsCartInMarkInitial();

  if (goCart2Button != null) {
    goCart2Button.addEventListener("click", (e) => {
      if (!checkLineItemValidation()) {
        e.preventDefault();
      }
    });
  }

  // const backCart1Button = document.getElementById("backCart1");
  // backCart1Button.addEventListener('click', (e) => {
  //   e.preventDefault();
  //   url.searchParams.delete('page');
  //   window.history.pushState({}, '', url);
  //   showCart1();
  // });

  // const goCheckoutButton = document.getElementById("goCheckout");
  // goCheckoutButton.addEventListener("click", (e) => {
  //   let deliveryDate = document.querySelector("div.delivery-select-container__select > div");
  //   if (deliveryDate) {
  //     deliveryDate = new Date(deliveryDate.innerText);
  //     const leadTime = 4;
  //     const now = new Date();
  //     const currentLeadDate = new Date(now.setDate(now.getDate() + leadTime - 1)); // ○日後 今日の日付からの正しいリードタイム日を計算
  //     if (currentLeadDate.getTime() > deliveryDate.getTime()) {
  //       e.preventDefault();
  //       console.log("*You have requested a date and time that is shorter than the past date and time and possible delivery date.");
  //       document.getElementById("delivery-before-leadtime").classList.remove("no-content");
  //       return;
  //     }
  //   }
  // });

  const sizeSelectores = document.querySelectorAll(".property-wrist-size"); //手首サイズ
  if (sizeSelectores) {
    for (const select of sizeSelectores) {
      // init
      if (select.value && select.value !== "調整なし") {
        const itemContainer = select.closest(".cart__item");
        // enableFitSelect(itemContainer);
      }

      select.addEventListener("change", (e) => {
        const itemContainer = select.closest(".cart__item");
        if (e.target.value === "調整なし") {
          // disenableFitSelect(itemContainer);

          updateLineProperty(itemContainer);
        } else {
          // enableFitSelect(itemContainer);
          updateLineProperty(itemContainer);
        }
      });
    }
  }

  const markTypeSelectors = document.querySelectorAll(
    ".mark-initial-flex-item input[type='radio']"
  ); //刻印文字
  if (markTypeSelectors) {
    for (const radio of markTypeSelectors) {
      // init
      if (radio.checked) {
        const itemContainer = radio.closest(".cart__item");
        enableInitialInput(itemContainer, radio.value);
      }

      radio.addEventListener("change", (e) => {
        if (e.target.checked) {
          const itemContainer = radio.closest(".cart__item");
          enableInitialInput(itemContainer, e.target.value);
          updateLineProperty(itemContainer);
        }
      });
    }
  }

  const markLetterInputs = document.querySelectorAll(
    ".mark-initial-flex-item input[type='text']"
  ); // 英小文字入力欄
  if (markLetterInputs) {
    for (const input of markLetterInputs) {
      input.addEventListener("change", (e) => {
        if (e.target.value != "") {
          const itemContainer = input.closest(".cart__item");
          if (/[A-Za-z]/.test(input.value)) {
            input.value = input.value.toUpperCase();
            updateLineProperty(itemContainer);
          } else {
            input.value = "";
          }
        }
      });
    }
  }

  const markSelectUsage = document.querySelectorAll(
    "select.property-initial-usage"
  ); //字体
  if (markSelectUsage) {
    for (const select of markSelectUsage) {
      select.addEventListener("change", (e) => {
        if (e.target.value != "") {
          const itemContainer = select.closest(".cart__item");
          updateLineProperty(itemContainer);
        }
      });
    }
  }

  const initialFormClearButton = document.querySelectorAll(
    ".initial-clear__button"
  );
  if (initialFormClearButton) {
    for (const button of initialFormClearButton) {
      button.addEventListener("click", (e) => {
        const itemContainer = button.closest(".cart__item");
        clearMarkForm(itemContainer);
        updateLineProperty(itemContainer);
      });
    }
  }

  const wrappingCheckbox = document.getElementById("orderWrapping");
  if (wrappingCheckbox) {
    wrappingCheckbox.addEventListener("change", (e) => {
      let wrappingValue = "必要";
      if (e.target.checked === false) {
        wrappingValue = "不要";
      }
      updateOrderWrappingAttribute(wrappingValue);
    });
    // init
    //use localstorage for wrapping item
    const wrappingValue = localStorage.getItem("wrapping");
    if (wrappingValue == "必要") {
      updateOrderWrappingAttribute("必要");
      wrappingCheckbox.checked = true;
    } else {
      updateOrderWrappingAttribute("不要");
    }
  }

  const cartNote = document.getElementById("CartNote");
  if (cartNote) {
    cartNote.addEventListener("change", (e) => {
      updateOrderNote(e.target.value);
    });
  }

  const receiveTypeSelect = document.querySelectorAll(
    "input[name='attributes[受取方法]']"
  );
  const receiveTypeSelectChecked = document.querySelector(
    "input[name='attributes[受取方法]']:checked"
  );
  if (receiveTypeSelectChecked) {
    // init
    if (receiveTypeSelectChecked.value === "発送") {
      displayDeliveryModule();
    } else if (receiveTypeSelectChecked.value === "店舗受取") {
      displayReceiveShop();
    }
  }
  if (receiveTypeSelect) {
    for (const select of receiveTypeSelect) {
      select.addEventListener("change", (e) => {
        if (e.target.value === "発送") {
          displayDeliveryModule();
        } else if (e.target.value === "店舗受取") {
          displayReceiveShop();
        }
      });
    }
  }

  // const spCart2ToggleButton = document.querySelector("#shopify-section-main-cart2 button.collapsible-trigger");
  // spCart2ToggleButton.addEventListener("click", (e) => {
  //   // console.log(spCart2ToggleButton.classList.contains("is-open"));
  //   if (spCart2ToggleButton.classList.contains("is-open")) {
  //     document.getElementById("toggleButtonText").innerText = "注文概要の非表示";
  //   } else {
  //     document.getElementById("toggleButtonText").innerText = "注文内容の表示";
  //   }
  // })
});

function showCart1() {
  const cart1 = document.getElementById("cartPage1");
  const cart2 = document.getElementById("cartPage2");
  const header = document.getElementById("shopify-section-header");
  const footer = document.getElementById("shopify-section-footer");
  cart1.classList.remove("no-content");
  cart2.classList.add("no-content");
  header.classList.remove("no-content");
  footer.classList.remove("no-content");
  window.scrollTo(0, 0);
}
//   function showCart2() {
//     const cart1 = document.getElementById("cartPage1");
//     const cart2 = document.getElementById("cartPage2");
//     const header = document.getElementById("shopify-section-header");
//     const footer = document.getElementById("shopify-section-footer");
//     cart1.classList.add("no-content");
//     cart2.classList.remove("no-content");
//     header.classList.add("no-content");
//     footer.classList.add("no-content");
//     window.scrollTo(0, 0);
//   }

function enableCartButton() {
  const checkoutButton = document.querySelectorAll("button.cart__checkout");
  for (button of checkoutButton) {
    button.classList.remove("disenable-function");
  }
}
function disenableCartButton() {
  const checkoutButton = document.querySelectorAll("button.cart__checkout");
  for (button of checkoutButton) {
    button.classList.add("disenable-function");
  }
}
function disenableFitSelect(container) {
  const fitTypeSelect = container.querySelector(".fit-type");
  fitTypeSelect.classList.add("disenable-function");
  if (fitTypeSelect.querySelector("input:checked")) {
    // if already checked, clear value
    fitTypeSelect.querySelector("input:checked").checked = false;
  }
}
function enableFitSelect(container) {
  const fitTypeSelect = container.querySelector(".fit-type");
  fitTypeSelect.classList.remove("disenable-function");
}
function disenableInitialInput(container) {
  const lettersSend = container.querySelector(".initial-letters-send");
  const lettersOwn = container.querySelector(".initial-letters-own");
  const selectUsage = container.querySelector(".property-initial-usage");
  lettersSend.classList.add("disenable-function");
  lettersOwn.classList.add("disenable-function");
  selectUsage.classList.add("disenable-function");
}
function enableInitialInput(container, checkedValue) {
  const lettersSend = container.querySelector(".initial-letters-send");
  const lettersOwn = container.querySelector(".initial-letters-own");
  const selectUsage = container.querySelector(".property-initial-usage");
  if (checkedValue === "贈答用") {
    lettersSend.classList.remove("disenable-function");
    lettersOwn.classList.add("disenable-function");
  } else if (checkedValue === "ご自身用") {
    lettersSend.classList.add("disenable-function");
    lettersOwn.classList.remove("disenable-function");
  }
  selectUsage.classList.remove("disenable-function");
}

function clearMarkForm(itemContainer) {
  const markType = itemContainer.querySelector(
    ".mark-initial-flex-item input[type='radio']:checked"
  );
  const sendInital1 = itemContainer.querySelector(
    "input.initial-letter-input__send1"
  );
  const sendInital2 = itemContainer.querySelector(
    "input.initial-letter-input__send2"
  );
  const ownInital1 = itemContainer.querySelector(
    "input.initial-letter-input__own1"
  );
  const ownInital2 = itemContainer.querySelector(
    "input.initial-letter-input__own2"
  );
  const initialUsage = itemContainer.querySelector(
    "select.property-initial-usage"
  );
  if (markType) {
    markType.checked = false;
    sendInital1.value = "";
    sendInital2.value = "";
    ownInital1.value = "";
    ownInital2.value = "";
    initialUsage.value = "";
    disenableInitialInput(itemContainer);
    const initialMeta = document.getElementById(
      `initialMeta__${itemContainer.dataset.productId}`
    );
    if (initialMeta) {
      initialMeta.innerText = "";
    }
  }
}

function displayDeliveryModule() {
  const shopReceive = document.getElementById("shop-receive-select");
  const deliveryModule = document.getElementById("deliverySection");
  shopReceive.classList.add("no-content");
  if (deliveryModule) {
    deliveryModule.classList.remove("no-content");
    document
      .getElementById("delivery-no-module-text")
      .classList.add("no-content");
  }
  const checkShop = shopReceive.querySelector(
    "input[name='attributes[受取店舗]']:checked"
  );
  if (checkShop) {
    checkShop.checked = false;
  }
}

function displayReceiveShop() {
  const shopReceive = document.getElementById("shop-receive-select");
  const deliveryModule = document.getElementById("deliverySection");
  shopReceive.classList.remove("no-content");
  if (deliveryModule) {
    deliveryModule.classList.add("no-content");
    document
      .getElementById("delivery-no-module-text")
      .classList.remove("no-content");
    // delete deliver selected value
    const cancelDate = deliveryModule.querySelector(
      ".delivery-select-container--close"
    );
    if (cancelDate) {
      cancelDate.click();
    }
    const timeSelect = deliveryModule.querySelector(
      "select[name='delivery_time']"
    );
    if (timeSelect) {
      timeSelect.value = "";
    }
  }
  const shopGinza = shopReceive.querySelector(
    "input[name='attributes[受取店舗]'][value='銀座店']"
  );
  if (shopGinza) {
    shopGinza.checked = true;
  }
}

function updateLineProperty(itemContainer) {
  disenableCartButton();
  const productLine = itemContainer.dataset.line;
  const wristSize = itemContainer.querySelector(
    `select[name='properties[手首サイズ]_item${productLine}']`
  );
  const fitType = itemContainer.querySelector(
    `input[name='properties[フィットタイプ]_item${productLine}']:checked`
  );
  const markType = itemContainer.querySelector(
    `input[name='properties[刻印文字]_item${productLine}']:checked`
  );
  const sendInital1 = itemContainer.querySelector(
    `input[name='properties[贈答用イニシャル1]_item${productLine}']`
  );
  const sendInital2 = itemContainer.querySelector(
    `input[name='properties[贈答用イニシャル2]_item${productLine}']`
  );
  const ownInital1 = itemContainer.querySelector(
    `input[name='properties[ご自身用イニシャル1]_item${productLine}']`
  );
  const ownInital2 = itemContainer.querySelector(
    `input[name='properties[ご自身用イニシャル2]_item${productLine}']`
  );
  const initialUsage = itemContainer.querySelector(
    `select[name='properties[字体]_item${productLine}']`
  );
  let wristData = {};
  let markData = {};
  if (wristSize) {
    wristData = {
      _手首サイズ: wristSize.value,
      // _フィットタイプ: fitType ? fitType.value : "指定なし", // SEIKOではフィットタイプは使用しない
    };
  }
  if (markType && markType.value === "贈答用") {
    markData = {
      _刻印文字: markType.value,
      _贈答用イニシャル1: sendInital1.value,
      _贈答用イニシャル2: sendInital2.value,
      _字体: initialUsage.value,
    };
  } else if (markType && markType.value === "ご自身用") {
    markData = {
      _刻印文字: markType.value,
      _ご自身用イニシャル1: ownInital1.value,
      _ご自身用イニシャル2: ownInital2.value,
      _字体: initialUsage.value,
    };
  }
  const formData = {
    line: Number(productLine),
    properties: {
      ...wristData,
      ...markData,
    },
  };
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      isCartInMarkInitial(data)
      // console.log(response.json());
      const wristMeta = document.getElementById(
        `wriseSizeMeta__${itemContainer.dataset.productId}`
      );
      if (wristMeta) {
        wristMeta.innerHTML = `手首サイズ: ${wristSize.value} / ${
          fitType ? fitType.value : "指定なし"
        }`;
      }
      const initialMeta = document.getElementById(
        `initialMeta__${itemContainer.dataset.productId}`
      );
      // console.log(initialMeta);
      // console.log(markType);
      if (initialMeta && markType) {
        if (markType.value === "贈答用") {
          initialMeta.innerHTML = `刻印: ${sendInital1.value}<span class="initial-letter-space"></span>to<span class="initial-letter-space"></span>${sendInital2.value}（${initialUsage.value}）`;
        } else if (markType.value === "ご自身用") {
          initialMeta.innerHTML = `刻印: ${ownInital1.value}・${ownInital2.value}（${initialUsage.value}）`;
        }
      }
      enableCartButton();
    })
    .catch((error) => {
      console.error("Error", error);
    });
}

function updateOrderNote(value) {
  console.log(value);
  disenableCartButton();
  const formData = {
    note: value,
  };
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      console.log(response.json());
      // document.getElementById("orderNoteInfo").innerText = value;
      enableCartButton();
    })
    .catch((error) => {
      console.error("Error", error);
    });
}

function updateOrderWrappingAttribute(value) {
  const wrapping = document.getElementById("doYouNeedWrapping");
  wrapping.value = value;
  localStorage.setItem("wrapping", value);
  const wrappingValue = localStorage.getItem("wrapping");
  console.log(wrappingValue);
}
function updateOrderShopInfoAttribute(value) {
  disenableCartButton();
  const formData = {
    attributes: {
      ラッピング: value,
    },
  };
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      // console.log(response.json());
      enableCartButton();
    })
    .catch((error) => {
      console.error("Error", error);
    });
}

function checkLineItemValidation() {
  let validationFlag = true;
  let wristValidationError = false;
  let markValidationError = false;
  const cartItems = document.querySelectorAll(".cart__page-col .cart__item");
  const errorTexts = document.querySelectorAll(".line-error-text");
  if (errorTexts) {
    for (const text of errorTexts) {
      text.remove();
    }
  }
  for (const item of cartItems) {
    const wristSize = item.querySelector(".wrist-size");
    const initialTypeChecked = item.querySelector(
      ".mark-initial-flex-item input[type='radio']:checked"
    );

    if (wristSize) {
      (function () {
        // check wristSize validate
        const wristSizeValue = wristSize.querySelector(
          "select.property-wrist-size"
        ).value;
        console.log(wristSizeValue);
        if (!wristSizeValue) {
          const error = document.createElement("p");
          error.classList.add("line-error-text", "font-gothic");
          error.innerText = "※手首サイズを選択してください";
          wristSize.after(error);
          wristValidationError = true;
          validationFlag = false;
        }
      })();
    }
    if (initialTypeChecked) {
      (function () {
        // if checked initialType, check mark validate
        if (initialTypeChecked.value === "贈答用") {
          const initial1 = item.querySelector(
            "input.initial-letter-input__send1"
          );
          const initial2 = item.querySelector(
            "input.initial-letter-input__send2"
          );
          if (!initial1.value || !initial2.value) {
            const markContainer = item.querySelector(
              ".mark-initial-flex-item1"
            );
            const error = document.createElement("p");
            error.classList.add("line-error-text", "font-gothic");
            error.innerText = "※イニシャルを入力してください";
            markContainer.appendChild(error);
            markValidationError = true;
            validationFlag = false;
          }
        } else if (initialTypeChecked.value === "ご自身用") {
          const initial1 = item.querySelector(
            "input.initial-letter-input__own1"
          );
          const initial2 = item.querySelector(
            "input.initial-letter-input__own2"
          );
          if (!initial1.value || !initial2.value) {
            const markContainer = item.querySelector(
              ".mark-initial-flex-item1"
            );
            const error = document.createElement("p");
            error.classList.add("line-error-text", "font-gothic");
            error.innerText = "※イニシャルを入力してください";
            markContainer.appendChild(error);
            markValidationError = true;
            validationFlag = false;
          }
        }
        const markUsageSelect = item.querySelector(
          "select.property-initial-usage"
        );
        if (!markUsageSelect.value) {
          const markContainer = item.querySelector(".mark-initial-flex-item2");
          const error = document.createElement("p");
          error.classList.add("line-error-text", "font-gothic");
          error.innerText = "※字体を選択してください";
          markContainer.appendChild(error);
          markValidationError = true;
          validationFlag = false;
        }
      })();
    }
  }
  if (!validationFlag) {
    alert(`※入力内容に不備があります。${wristValidationError ? "\n手首サイズを選択してください。" : ""}${markValidationError ? "\n刻印情報を入力してください。" : ""}`);
  }
  // console.log(validationFlag);
  return validationFlag;
}

function initIsCartInMarkInitial() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((data) => {
      // console.log(data);
      isCartInMarkInitial(data)
    })
    .catch((error) => {
      console.error("Error", error);
    })
}

function isCartInMarkInitial(data) {
  let isCartInInitial = false;
  for (const item of data.items) {
    if (item.properties.hasOwnProperty('刻印文字')) {
      isCartInInitial = true;
    }
  }
  if (isCartInInitial) {
    const deliveryModule = document.getElementById("delivery-module");
    if (deliveryModule) {
      deliveryModule.classList.add("disabled");
      // delete deliver selected value
      // const dateSelect = deliveryModule.querySelector("select[name='delivery_date']");
      // if (dateSelect) {
      //   dateSelect.value = "";
      // }
      // const timeSelect = deliveryModule.querySelector("select[name='delivery_time']");
      // if (timeSelect) {
      //   timeSelect.value = "";
      // }
    }
  } else {
    const deliveryModule = document.getElementById("delivery-module");
    if (deliveryModule) {
      deliveryModule.classList.remove("disabled");
    }
  }
}